import script from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordForm.vue?vue&type=style&index=0&id=56b4efb5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56b4efb5"]])

export default __exports__